export const GoogleSolidButtonStyles = {
    baseStyles : "text-white hover:bg-none hover:bg-[#E64E4E] hover:text-white w-full flex items-center justify-center gap-2.5 break-words py-2 px-4 border border-[#dee0e6] rounded-lg text-[16px] leading-[24px] font-bold bg-gradient-to-r from-iw-primary to-iw-secondary",
    disabledClasses : "bg-iw-disabled text-white shadow-none cursor-not-allowed"
}